import { HStack } from '~/components/layout/Stack';
import Text from '~/components/typographies/Text';

export const PreviewField = ({ label, value }: { label: string; value: string }) => (
  <HStack gap={0.5} align="center">
    <Text variant="caption" weight="semibold">
      {label}:
    </Text>
    <Text variant="caption" weight="medium">
      {value}
    </Text>
  </HStack>
);
